import { EventName } from "game/events/eventsName";
import { GameEvent } from "game/events/gameEvent";
import { GAEvent, GAEventNames } from "game/analytics/events";
import { Store } from "game/store/gameStore";
import { updateUIState } from "ui/index";
import { uiStore } from "ui/store";
import { UIState } from "ui/types/gameUI";

export class NewGameHandler {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('ui-button-click', this.handleUIButtonClick.bind(this));
    }

    handleUIButtonClick(event: Event) {
        const customEvent = event as CustomEvent;
        const { buttonKey } = customEvent.detail;

        switch (buttonKey) {
            case 'new-game':
                this.onOpenNewGame();
                break;
            case 'close-new-game':
                this.onCloseNewGame();
                break;
        }
    }

    private onOpenNewGame() {
        if (uiStore.getState().gameUI.modals.newGameModal?.isOpen) {
            return;
        }
        
        GameEvent.emit(EventName.OPEN_SETTINGS);
        GAEvent(GAEventNames.OPEN_NEW_GAME_POPUP, {
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
        });

        this.updateUI({
            modals: {
                ...uiStore.getState().gameUI.modals,
                newGameModal: { isOpen: true },
                settingsModal: { isOpen: false },
                designModal: { ...uiStore.getState().gameUI.modals.designModal, isOpen: false },
                storiesModal: { ...uiStore.getState().gameUI.modals.storiesModal, isOpen: false },
                missionsModal: { ...uiStore.getState().gameUI.modals.missionsModal, isOpen: false },
            },
            isExpanded: true
        });
    }

    private onCloseNewGame() {
        GameEvent.emit(EventName.HIDE_SETTINGS);

        this.updateUI({
            modals: {
                ...uiStore.getState().gameUI.modals,
                newGameModal: { isOpen: false },
            },
            isExpanded: false
        });
    }

    updateUI(updates: Partial<UIState>) {
        uiStore.dispatch(updateUIState(updates));
    }
}